import React, { useContext } from 'react';
import { EXTERNAL_ROUTES } from '../../static/Urls';
import { Common } from '../../static/Messages';
import { MessageContext } from '../../locale/MessageProvider';

const Header: React.FC = () => {
  const messageFormatter = useContext(MessageContext);

  return (
    <header className="page-header page-header--white page-header--white--composite" role="banner">
      <div className="content-wrapper vertical-center-container">
        <a
          href={EXTERNAL_ROUTES.SCOUT_MANAGER_PATH}
          title="ImmobilienScout24"
          aria-label="ImmobilienScout24"
          target="_self"
          className="page-header__logo vertical-center"
        >
          <div>
            <img
              alt="ImmobilienScout24"
              width="116px"
              height="40px"
              src="https://www.immobilienscout24.de/etc/designs/is24/img/immoscout24.svg"
            />
          </div>
        </a>
        <span className="padding-left-m" style={{ fontWeight: 600 }}>
          {messageFormatter.formatCommonMessage(Common.serviceName)}
        </span>
        <span className="float-right">
          <a className="font-regular" href={EXTERNAL_ROUTES.LOGOUT_PATH}>
            {messageFormatter.formatCommonMessage(Common.logout)}
          </a>
        </span>{' '}
        <span className="float-right margin-right">
          <a className="font-regular" target={'_blank'} href={EXTERNAL_ROUTES.SUPPORT_FEEDBACK_PATH}>
            {messageFormatter.formatCommonMessage(Common.supportFeedback)}
          </a>
        </span>
        <span className="float-right margin-right">
          <a className="font-regular" target={'_blank'} href={EXTERNAL_ROUTES.DEV_PORTAL_PATH}>
            {messageFormatter.formatCommonMessage(Common.devPortalName)}
          </a>
        </span>
      </div>
    </header>
  );
};

export default Header;
